// extracted by mini-css-extract-plugin
module.exports = {"container":"Payment_container__ERh-B","wrapper":"Payment_wrapper__2PsLM","mainBox":"Payment_mainBox__2lWN8","heading":"Payment_heading__aZaZZ","buttons":"Payment_buttons__3XJa1"};